import { render, staticRenderFns } from "./EdiMessage.vue?vue&type=template&id=0a1f9c61&"
import script from "./EdiMessage.vue?vue&type=script&lang=js&"
export * from "./EdiMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports